import { Component, Input, inject } from '@angular/core';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { LoanRequest } from 'src/model/loanRequest.model';
import { LoanRequestService } from 'src/services/loan-request.service';

@Component({
    selector: 'app-loan-request-approval',
    templateUrl: './loan-request-approval.component.html',
    styleUrls: ['./loan-request-approval.component.scss'],
    standalone: false
})
export class LoanRequestApprovalComponent {
  protected sharedService = inject(SharedService);
  protected enums = inject(Enums);
  private lrService = inject(LoanRequestService);

  @Input() requestList: LoanRequest[] = [];
  @Input() loanGroupId: number;
  @Input() clashedTickets: LoanRequest[];

  remark = "";

  checkIfAllowApproval() {
    if (this.sharedService.isBossAccount())
      return true;
    else if (this.sharedService.isAdmin()) {
      this.requestList.forEach(request => {
        if (request.ProcessRequiredRole != this.enums.ADMIN || request.VerifiedOn == undefined)
          return false
      });
      return true;
    }
  }

  confirmBeforeAction(action: string) {
    if (this.remark == "" && action == 'deny')
      this.sharedService.openAlert("Please key in denial reason", ALERT_TYPE.DANGER);
    else {
      const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);

      //construct confirmation ticket ids
      let requestIds = "";
      this.requestList.forEach(request => {
        requestIds += "#" + request.ID + " "
      });
      let clashedIds = "";
      //if contains clashed tickets also need to let them know, only when the action == "approve", because if =="deny", no need to process other tickets
      if (action == "approve") {
        var clashMsg = "";
        (this.clashedTickets != undefined) ? this.clashedTickets.forEach(r => { clashedIds += "#" + r.ID + "" }) : "";
        clashMsg = (clashedIds == "") ? "" : "\nAt the same time will DENY " + clashedIds;
      }

      const confirmMsg = "Are you confirm to " + action + " loan TICKET " + requestIds + "?";
      modalRef.componentInstance.message = confirmMsg + (clashMsg ?? "");
      modalRef.componentInstance.needExtraConfirm = (this.clashedTickets != undefined && this.clashedTickets.length > 0);
      modalRef.componentInstance.confirmationType = (this.clashedTickets != undefined && this.clashedTickets.length > 0) ? this.enums.WARNING_CONFIRMATION : this.enums.INFO_CONFIRMATION;

      modalRef.result.then(async (confirm) => {
        if (confirm) {
          let res;
          if (action == 'approve') {
            //need to process the current ticket regardless if there is any clashed tickets
            const processTicketList = [{ lgId: this.requestList[0].LoanGroupId, remark: this.remark, approve: true }];

            //if there is clash tickets need to add those into process ticket list
            if (this.clashedTickets != undefined && this.clashedTickets.length > 0) {
              const clashedLoanGroups = Array.from(new Set(this.clashedTickets.map(c => c.LoanGroupId)));
              clashedLoanGroups.forEach(g => {
                processTicketList.push({ lgId: g, remark: this.remark + "| Denied:" + clashedIds + " Approved: " + requestIds, approve: false })
              });
            }
            res = await this.lrService.processMultipleSharedLoanRequest(processTicketList);
          }

          //if deny current ticket no need to do multiple process. Only deny current
          else {
            res = await this.lrService.processSharedLoanRequest(this.loanGroupId, this.remark, false)
          }

          if (res != undefined)
            window.location.reload();
        }
      });
    }
  }
}
